import { render } from "./situation_new3.vue?vue&type=template&id=4ab67517&scoped=true"
import script from "./situation_new3.vue?vue&type=script&lang=js"
export * from "./situation_new3.vue?vue&type=script&lang=js"

import "./situation_new3.vue?vue&type=style&index=0&id=4ab67517&lang=scss&scoped=scoped"
import "./situation_new3.vue?vue&type=style&index=1&id=4ab67517&scoped=true&lang=css"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab67517"]])

export default __exports__